import { parseSerialFormatter } from '#/modules/imsMgmt/settings/mtrTemplate/helper/serialFormatterSerialize';

function findMainCode(treeRows, mainId) {
  if (!mainId) {
    return '';
  }

  const main = treeRows.find((row) => row.id === mainId);
  return main?.code ?? '';
}

function findSubCode(treeRows, subId) {
  if (!subId) {
    return '';
  }

  for (const main of treeRows) {
    const sub = (main.subList ?? []).find((row) => row.id === subId);
    if (sub) {
      return sub.code ?? '';
    }
  }

  return '';
}

function findManufacturerCode(manufacturers, manufacturerId) {
  if (!manufacturerId) {
    return '';
  }

  const manufacturer = manufacturers.find((row) => row.id === manufacturerId);
  return manufacturer?.code ?? manufacturer?.name ?? '';
}

function findSpecEntry(specEntries, mtrSpecId) {
  return (specEntries ?? []).find((entry) => entry.mtrSpecId === mtrSpecId);
}

function resolveSelectOptionCode(specDetailsById, mtrSpecId, optionId) {
  if (!mtrSpecId || !optionId) {
    return '';
  }

  const options = specDetailsById?.[mtrSpecId]?.options ?? [];
  const option = options.find((row) => row.id === optionId);
  return option?.code ?? option?.name ?? '';
}

function resolveMtrSpecSegment(mtrSpecId, context) {
  const entry = findSpecEntry(context.formValues?.specEntries, mtrSpecId);
  if (!entry) {
    return '';
  }

  if (entry.specType === 'SELECT') {
    return resolveSelectOptionCode(
      context.specDetailsById,
      mtrSpecId,
      entry.mtrSpecOptionId,
    );
  }

  return entry.inputValue?.trim() ?? '';
}

function resolveSpecEnumSegment(mtrSpecId, context) {
  return resolveMtrSpecSegment(mtrSpecId, context);
}

function resolveSpecValueSegment(mtrSpecId, context) {
  const entry = findSpecEntry(context.formValues?.specEntries, mtrSpecId);
  return entry?.inputValue?.trim() ?? '';
}

function resolveSegment(item, context) {
  const type = item?.type ?? '';

  switch (type) {
    case 'mtr_struct_main_id':
    case 'material_struct_parent_uuid':
      return findMainCode(context.treeRows, context.formValues?.mtrStructMainId);
    case 'mtr_struct_sub_id':
    case 'material_struct_uuid':
      return findSubCode(context.treeRows, context.formValues?.mtrStructSubId);
    case 'manufacture':
      return findManufacturerCode(
        context.manufacturers,
        context.formValues?.manufacturerId,
      );
    case 'mtr_spec':
      return resolveMtrSpecSegment(item.value, context);
    case 'spec_enum':
      return resolveSpecEnumSegment(item.value, context);
    case 'spec_value':
      return resolveSpecValueSegment(item.value, context);
    case 'custom':
      return item.label || item.value || '';
    default:
      return '';
  }
}

/**
 * 依模板 serialFormatter 與表單值組出料號（純前端，與 v1 buildSerialFromFormatter 對齊）。
 */
export function buildMtrNoFromSerialFormatter(serialFormatterRaw, formValues = {}, context = {}) {
  const items = parseSerialFormatter(serialFormatterRaw);

  if (items.length === 0) {
    return '';
  }

  const parts = items.map((item) => resolveSegment(item, {
    treeRows: context.treeRows ?? [],
    manufacturers: context.manufacturers ?? [],
    specDetailsById: context.specDetailsById ?? {},
    formValues,
  }));

  return parts.join('');
}
